// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { EyeOff } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconEyeOff(props: any) {
    return <IconBase icon={EyeOff} {...props} />
  }

  export default IconEyeOff
  